import handleClick from "../../utils/handleClick.js";
import useVisible from "../../hooks/useVisible.jsx";
import "./NormalizeTrackMatte.css"; // Подключаем стили

function NormalizeTrackMatte({ selectedTag, buttonTags, generateButtonTags }) {
  const [isVisible, setIsVisible] = useVisible("NormalizeTrackMatteVisibility");
  const [size, setSize] = useVisible("NormalizeTrackMatteSize");
  const [order, setOrder] = useVisible("NormalizeTrackMatteOrder");

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  const isActionDisabled = !size && !order;
  const getOptions = (type) => ({ type, size, order });

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i className="fa-sharp fa-solid fa-down-to-line"></i>
          <div />
        </div>
        <div className="button-card__title">Normalize Track Matte</div>
        {generateButtonTags()}
      </li>

      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        {/* Radio Buttons */}
        <div className="render-group__checkbox-group">
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="normalize-trackmatte-order"
              checked={!!order}
              onChange={() => setOrder(!order)}
              className="hidden-checkbox"
            />
            <label htmlFor="normalize-trackmatte-order">
              <span className="custom-checkbox"></span>
              <span className="label-text">Order</span>
            </label>
          </div>
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="normalize-trackmatte-size"
              checked={!!size}
              onChange={() => setSize(!size)}
              className="hidden-checkbox"
            />
            <label htmlFor="normalize-trackmatte-size">
              <span className="custom-checkbox"></span>
              <span className="label-text">Size</span>
            </label>
          </div>
        </div>

        <div className="render-group__tools-grid">
          {/* Action Buttons */}
          <div
            onClick={
              isActionDisabled
                ? undefined
                : () => handleClick("ppNormalizeTrackMatte", getOptions("layer"))
            }
            className={`resolution-tools__button ${isActionDisabled ? "disabled" : ""}`}
            aria-disabled={isActionDisabled}
          >
            <i className="fa-light fa-layer-group"></i>
            <span>Selected Layers</span>
          </div>
          <div
            onClick={
              isActionDisabled
                ? undefined
                : () => handleClick("ppNormalizeTrackMatte", getOptions("comp"))
            }
            className={`resolution-tools__button ${isActionDisabled ? "disabled" : ""}`}
            aria-disabled={isActionDisabled}
          >
            <i className="fa-solid fa-image-polaroid"></i>
            <span>Active Comp</span>
          </div>
          <div
            onClick={
              isActionDisabled
                ? undefined
                : () =>
                    handleClick("ppNormalizeTrackMatte", getOptions("selected comp"))
            }
            className={`resolution-tools__button ${isActionDisabled ? "disabled" : ""}`}
            aria-disabled={isActionDisabled}
          >
            <i className="fa-solid fa-images"></i>
            <span>Selected Comp</span>
          </div>
          <div
            onClick={
              isActionDisabled
                ? undefined
                : () => handleClick("ppNormalizeTrackMatte", getOptions("project"))
            }
            className={`resolution-tools__button ${isActionDisabled ? "disabled" : ""}`}
            aria-disabled={isActionDisabled}
          >
            <i className="fa-regular fa-photo-film"></i>
            <span>Project</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default NormalizeTrackMatte;
